export default "__VITE_ASSET__DNxhrr1c__"